import { WindowWrapper } from './globalWrappers';
import * as _ from 'lodash';

export function isEnabled(flagName: FeatureFlagName) {
  return _.get(_.find(WindowWrapper.FEATURE_FLAGS, { _id: flagName }), 'enabled', false);
}
